import React from "react";
import { string, bool, object } from "prop-types";
import { Link } from "@quintype/components";

import "./menu-item.m.css";

const MenuItem = ({ item, toggleHandler, menuStyle = "menu-link" }) => {
  if (item["item-type"] === "placeholder") {
    return (
      <span styleName="menu-link" className={menuStyle}>
        {item.title}
      </span>
    );
  } else if (item["item-type"] === "link") {
    return (
      <a
        styleName="menu-link"
        onClick={toggleHandler}
        className={menuStyle}
        target="_blank"
        rel="noopener noreferrer"
        href={item.completeUrl || "/"}
      >
        {item.title}
      </a>
    );
  } else {
    return (
      <Link
        styleName="menu-link"
        aria-label="menu-item"
        callback={toggleHandler}
        className={menuStyle}
        href={item.completeUrl || "/"}
      >
        {item.title}
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: object,
  toggleHandler: bool,
  menuStyle: string,
};

export { MenuItem };
